import { Stack, useTheme, Box, Typography } from "@mui/material";
import { Toaster } from "react-hot-toast";

const AuthPageLayout = ({ children }) => {
  const theme = useTheme();
  return (
    <Stack
      flexDirection="row"
      bgcolor={theme.palette.background.main}
      height={"100vh"}
    >
      <Toaster />
      <Stack
        flex={0.5}
        p={5}
        sx={{ display: { xs: "none", sm: "none", md: "flex" } }}
      >
        <Box
          component="img"
          src="/logoNuevo.png"
          width={{ xs: "250px", xl: "340px" }}
        />
        <Box
          component="img"
          src="/Pestate.png"
          width={{ sm: "300px", xl: "350px" }}
          sx={{ margin: "auto", marginTop: { md: "70px", xl: "180px" } }}
        />
        <Typography sx={{ color: "white", fontSize: "1.1rem" }}>
          @2025 Plusvalica. Todos los Derechos Reservados. Términos y
          Condiciones
        </Typography>
      </Stack>
      <Stack
        flex={{ xs: 1, sm: 1, md: 0.54 }}
        bgcolor="white"
        justifyContent="center"
        alignItems="center"
      >
        <Box
          component="img"
          src="/PLUSVAL_STATE.png"
          width={{ xs: "140px", sm: "300px" }}
          sx={{
            display: { md: "none", sm: "block", xs: "block" },
            marginBottom: "30px",
          }}
        />
        {children}
      </Stack>
    </Stack>
  );
};

export default AuthPageLayout;
